import fetch from 'services/request';
import { IAddMediaLinkPayload, IApiGetLibraryMediaParam } from '../interfaces/api';

// const baseURL = 'api/v1/:merchant_code/demoData';

export const getDemoData = () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ data: { data: [] } });
    }, 1000);
  });
  // return fetch({
  //   method: 'get',
  //   url: `${baseURL}/getDemoData`,
  //   params: params as any
  // });
};


/**
 * TODO:
 * please replace media to your feature name
 * ex:
 * mediaApis => bookingApis
 */

const getListLibraryMedia = (path: string, keySearch?: string) => {
  return fetch({
    method: 'post',
    url: '/api/v1/manage-library',
    body: { path, keySearch },
  });
};

const deleteMediaItem = (id: string) => {
  return fetch({
    method: 'post',
    url: '/api/v1/manage-library/delete',
    body: { id },
  });
};

const uploadMediaItem = (formData: FormData) => {
  return fetch({
    method: 'post',
    url: '/api/v1/manage-library/upload',
    body: formData,
    configs: {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  });
};

const renameMediaItem = (id: string, newName: string) => {
  return fetch({
    method: 'post',
    url: '/api/v1/manage-library/rename',
    body: { id, newName },
  });
};

const createMediaFolder = (name: string, parentPath: string) => {
  return fetch({
    method: 'post',
    url: '/api/v1/manage-library/create-folder',
    body: { name, parentPath },
  });
};

const getLibraryLinks = (params: IApiGetLibraryMediaParam) => {
  return fetch({
    method: 'get',
    url: '/api/v1/manage-library/links',
    params,
  });
};

const createMediaLink = (body: IAddMediaLinkPayload) => {
  return fetch({
    method: 'post',
    url: '/api/v1/manage-library/add-link',
    body,
  });
};

const deleteMediaLink = (linkId: string) => {
  return fetch({
    method: 'delete',
    url: `/api/v1/manage-library/delete-link/${linkId}`,
  });
};

const moveToStore = (mediaId: string, shopIds: string[]) => {
  return fetch({
    method: 'post',
    url: '/api/v1/manage-library/assign-store',
    body: { mediaId, shopIds },
  });
};

const getAllFoldersInStore = (storeId: string) => {
  return fetch({
    method: 'get',
    url: `/api/v1/manage-library/${storeId}/all-folders`,
  });
};

const moveToFolder = (storeId: string, mediaId: string, targetPath: string) => {
  return fetch({
    method: 'post',
    url: `/api/v1/manage-library/${storeId}/move`,
    body: { mediaId, targetPath },
  });
};


const mediaApis = {
  getDemoData,
  getListLibraryMedia,
  deleteMediaItem,
  uploadMediaItem,
  renameMediaItem,
  createMediaFolder,
  getLibraryLinks,
  createMediaLink,
  deleteMediaLink,
  moveToStore,
  getAllFoldersInStore,
  moveToFolder,
};

export default mediaApis;
